// import anime from "animejs";
import Tab from "./Tab";
// import Cookie from "./Cookie";
import {parse} from '../../helpers/video'

import axios from 'axios'

export default class Lightbox {
  constructor() {
    this._lightbox = document.querySelector(".jsLightbox");
    this._lightboxMedia = document.querySelector(".jsLightboxMedia");
    // this._lightboxClose = document.querySelectorAll(".jsLightboxClose");
    this._lightboxClose = '';
    this._lightboxInit = document.querySelectorAll(".jsLightboxInit");

    if (this._lightbox) this.init();
  }

  openLightbox(src, type, caption) {
    let html = "";
    var element = document.createElement("div");

    switch (type) {
      case "ajax":
        axios.get(src).then((response) => {
          this._lightboxMedia.innerHTML = `<div class="lightbox-content">${response.data}</div>`
        })
        break;

      case "video":
        const video = parse(src)

        if (video.type == 'vimeo') {
          html = `<iframe style="background-color: black;" src="https://player.vimeo.com/video/${video.id}" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>`;
        }

        if (video.type == 'youtube') {
          html = `<iframe style="background-color: black;" src="https://www.youtube.com/embed/${video.id}?rel=0&amp;controls=0&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media"`
        }
        break;

      case "inline":
        const inline = document.getElementById(src).innerHTML;
        html = `<div class="lightbox-content inline">${inline}</div>`;
        break;

      case "form":
        const form_lightbox = document.getElementById(src);
        element.appendChild(form_lightbox.firstElementChild);
        break;

      case "img":
        html = `<div class="image image--lightbox">
          <img src="${src}" alt="lorem" class="image__box" />
          <div class="image__caption box box--padding">
            <span class="image__txt">${caption}</span>
          </div>
        </div>
        `;
        break;

      case "download-form":
        html = `download form code here`;
    }

    if ( type == "form" )
    {
      this._lightboxMedia.appendChild(element);
    }
    else
    {
      this._lightboxMedia.innerHTML = '<div>' + html + '</div>';
    }
  }

  closeLightbox() {
    this._lightbox.classList.remove("active");
    var element = this._lightboxMedia.getElementsByClassName("element")[0];
    if ( element )
    {
      var src_element = document.getElementById(element.dataset.src);
      if ( src_element )
      {
        src_element.appendChild(element);
      }
    }
    this._lightboxMedia.innerHTML = "";
  }

  init() {
    for (let i = 0; i < this._lightboxInit.length; i++) {
      const el = this._lightboxInit[i];

      // Check if popup
      var popup = 0;
      if ( el.hasAttribute('data-popup') ) {
        popup = el.dataset.popup;
      }

      let caption = el.dataset.credit || '';
      if ( popup == 1 ) {
        // var viewedPopup = Cookie.getCookie("viewedPopup");
        // if ( viewedPopup == "" ) {
        if ( !sessionStorage.alreadyClicked ) {
          this._lightbox.classList.add("active");
          this.openLightbox(el.dataset.src, el.dataset.type, caption);
          // Cookie.setCookie("viewedPopup", 1, 30);
          sessionStorage.alreadyClicked = "true";
        }
      } else {
        el.addEventListener("click", (event) => {
          event.preventDefault()
          this._lightbox.classList.add("active");
          this.openLightbox(el.dataset.src, el.dataset.type, caption);
        });
      }
    }

    // Add event listeners to close buttons
    this._lightboxClose = document.querySelectorAll(".jsLightboxClose");
    for (let i = 0; i < this._lightboxClose.length; i++) {
      const el = this._lightboxClose[i];

      el.addEventListener("click", (event) => {
        event.preventDefault();
        this.closeLightbox();
      });
    }
  }
}
